const initCustomSortBy = () => {
  const sortBySelectContainer = document.querySelector('[data-sort-by-select-container]');
  if (!sortBySelectContainer) return;

  if (sortBySelectContainer.dataset.sortByInitialized === 'true') return;
  sortBySelectContainer.dataset.sortByInitialized = 'true';

  const openSortOptionsButton = sortBySelectContainer.querySelector('[data-open-sort-options]');
  const sortInputEl = sortBySelectContainer.querySelector('[data-sort-by-select]');
  const sortByLabelEl = sortBySelectContainer.querySelector('[data-sort-by-label]');
  const sortByListBoxEl = sortBySelectContainer.querySelector('[data-sort-by-select-options]');
  if (!openSortOptionsButton || !sortInputEl || !sortByLabelEl || !sortByListBoxEl) return;

  const ariaSelectedAttribiute = 'aria-selected';
  const getSortOptions = () => [...sortBySelectContainer.querySelectorAll('[data-sort-by-select-option]')];

  const getSelectedOptionIndex = () => {
    const sortOptions = getSortOptions();
    const selectedOptionIndex = sortOptions.findIndex(option => option.getAttribute(ariaSelectedAttribiute) === 'true');
    return selectedOptionIndex >= 0 ? selectedOptionIndex : 0;
  };

  let currentOptionIndex = getSelectedOptionIndex();

  const pseudoFocusState = 'data-focus';

  // declare handleKeydown function here to avoid hoisting issues
  // and to allow it to be used in the setOptionListVisibility function
  let handleKeydown = () => { };

  const setOptionListVisibility = (isOpen) => {
    openSortOptionsButton.setAttribute('aria-expanded', String(isOpen));
    if (isOpen) {
      currentOptionIndex = getSelectedOptionIndex();
      sortBySelectContainer.setAttribute('open', '');
      sortBySelectContainer.addEventListener('keydown', handleKeydown);
      sortByListBoxEl.setAttribute('tabindex', '0');
      sortByListBoxEl.focus();
    } else {
      sortBySelectContainer.removeAttribute('open');
      sortBySelectContainer.removeEventListener('keydown', handleKeydown);
      openSortOptionsButton.focus();
      sortByListBoxEl.setAttribute('tabindex', '-1');
      getSortOptions().forEach(option => {
        option.removeAttribute(pseudoFocusState);
      });
    }
  };

  const selectOption = (selectedOptionElement) => {
    if (!selectedOptionElement) return;

    const value = selectedOptionElement.dataset.sortByValue;
    getSortOptions().forEach(sortOptionsEl => {
      sortOptionsEl.setAttribute(ariaSelectedAttribiute, 'false');
    });
    selectedOptionElement.setAttribute(ariaSelectedAttribiute, 'true');
    sortInputEl.value = value;
    sortByLabelEl.innerText = selectedOptionElement.innerText;
    sortInputEl.dispatchEvent(new Event('change'));
    setOptionListVisibility(false);
  };

  const focusCurrentOption = () => {
    const sortOptions = getSortOptions();
    const currentOption = sortOptions[currentOptionIndex];
    if (!currentOption) return;

    currentOption.focus();
    sortOptions.forEach(option => {
      option.removeAttribute(pseudoFocusState);
    });
    currentOption.setAttribute(pseudoFocusState, 'true');
  };

  const moveFocusWithKeyboard = (amount) => {
    const sortOptions = getSortOptions();
    if (!sortOptions.length) return;

    currentOptionIndex += amount;
    if (currentOptionIndex < 0) {
      currentOptionIndex = sortOptions.length - 1;
    } else if (currentOptionIndex >= sortOptions.length) {
      currentOptionIndex = 0;
    }
    focusCurrentOption();
  };

  handleKeydown = (e) => {
    const key = e.key;
    switch (key) {
      case 'Escape':
        setOptionListVisibility(false);
        break;
      case 'ArrowDown':
        e.preventDefault();
        moveFocusWithKeyboard(1);
        break;
      case 'ArrowUp':
        e.preventDefault();
        moveFocusWithKeyboard(-1);
        break;
      case 'Enter':
      case ' ':
        const selectedOptionElement = getSortOptions()[currentOptionIndex];
        selectOption(selectedOptionElement);
        break;
      default:
        break;
    }
  };

  openSortOptionsButton.addEventListener('click', () => {
    const isOpen = openSortOptionsButton.getAttribute('aria-expanded') === 'true';
    setOptionListVisibility(!isOpen);
  });

  sortByListBoxEl.addEventListener('click', (e) => {
    const selectedOptionElement = e.target.closest('[data-sort-by-select-option]');
    if (!selectedOptionElement) return;
    selectOption(selectedOptionElement);
  });
};

export default initCustomSortBy;
